export const DEFAULT_MESSAGES = {
  'high-demand':
    "Estamos com alta demanda neste momento, por favor aguarde alguns instantes que estamos trabalhando para resolver este problema.",
};
